export const I18nPageProperty = {
  waiterLayout: {
    order: {
      en: "Orders",
      tr: "Siparişler",
    },
  },
  common: {
    pendingApproval: {
      en: "Pending Approval",
      tr: "Onay Bekliyor",
    },
    approved: {
      en: "Approved",
      tr: "Onaylandı",
    },
    cancelled: {
      en: "Cancelled",
      tr: "İptal Edildi",
    },
    preparing: {
      en: "Preparing",
      tr: "Hazırlanıyor",
    },
    ready: {
      // YENİ
      en: "Ready",
      tr: "Servise Hazır",
    },
    delivered: {
      // YENİ
      en: "Served",
      tr: "Teslim Edildi",
    },
    outOfStock: {
      // YENİ
      en: "Out of Stock",
      tr: "Tükendi / Stok Yok",
    },
    logOut: {
      en: "Log Out",
      tr: "Çıkış Yap",
    },
    ok: {
      en: "Ok",
      tr: "Tamam",
    },
    cancel: {
      en: "Cancel",
      tr: "İptal",
    },
    orders: {
      en: "Orders",
      tr: "Siparişler",
    },
    amount: {
      en: "Amount",
      tr: "Adet",
    },
    sendOrder: {
      en: "Order Now",
      tr: "Sipariş Ver",
    },
    paymentNotMade: {
      en: "Payment Pending",
      tr: "Ödeme Bekliyor",
    },
    paymentCompleted: {
      en: "Payment Completed",
      tr: "Ödeme Tamamlandı",
    },
  },
  waiter: {
    confirmAllOrders: {
      en: "Confirm All Orders",
      tr: "Tümünü Onayla",
    },
    tableDetailTitle: {
      en: "Table {{number}} Orders",
      tr: "Masa {{number}} Siparişleri",
    },
    theWaiterIsCalling: {
      en: "The waiter is being called",
      tr: "Garson çağırılıyor",
    },
  },
  login: {
    title: {
      en: "Restaurant Menu",
      tr: "Restoran Menü",
    },
    userName: {
      en: "Username",
      tr: "Kullanıcı Adı",
    },
    email: {
      en: "E-mail",
      tr: "E-posta",
    },
    password: {
      en: "Password",
      tr: "Şifre",
    },
    login: {
      en: "Login",
      tr: "Giriş Yap",
    },
    language: {
      en: "Language",
      tr: "Dil",
    },
  },
  menuProduct: {
    orderNote: {
      en: "Note",
      tr: "Not",
    },
    addToBasket: {
      en: "Add to Basket",
      tr: "Sepete Ekle",
    },
    waiter: {
      en: "Waiter",
      tr: "Garson",
    },
    callTheWaiter: {
      en: "Call the waiter to the table?",
      tr: "Garson masaya çağrılsın mı?",
    },
  },
  template: {
    waiterFloat: {
      en: "Waiter",
      tr: "Garson",
    },
    waiter: {
      en: "Waiter",
      tr: "Garson",
    },
    companyManager: {
      en: "Company Manager",
      tr: "Firma Yöneticisi",
    },
    admin: {
      en: "Admin",
      tr: "Yönetici",
    },
    tableFloat: {
      en: "Table",
      tr: "Masa",
    },
    basketFloat: {
      en: "Basket",
      tr: "Sepet",
    },
  },
};

export enum I18nPagePropertyEnum {
  waiterLayoutOrder = "waiterLayout.order",
  //#region common
  commonPendingApproval = "common.pendingApproval",
  commonApproved = "common.approved",
  commonItIsCancelled = "common.itIsCancelled",
  commonOrderIsBeingPrepared = "common.orderIsBeingPrepared",
  commonPaymentNotMade = "common.paymentNotMade",
  commonPaymentCompleted = "common.paymentCompleted",
  commonOk = "common.ok",
  commonCancel = "common.cancel",
  commonAmount = "common.amount",
  commonLogOut = "common.logOut",
  commonSendOrder = "common.sendOrder",
  commonReadyToServe = "common.readyToServe",
  commonDelivered = "common.delivered",
  commonOutOfStock = "common.outOfStock",
  commonPreparing = "common.preparing",
  commonReady = "common.ready",
  //#endregion
  //#region waiter
  waiterConfirmAllOrders = "waiter.confirmAllOrders",
  waiterTableDetailTitle = "waiter.tableDetailTitle",
  waiterTheWaiterIsCalling = "waiter.theWaiterIsCalling",
  //#endregion
  //#region login
  loginTitle = "login.title",
  loginUserName = "login.userName",
  loginEmail = "login.email",
  loginPassword = "login.password",
  loginLogin = "login.login",
  loginLanguage = "login.language",
  //#endregion
  //#region menuProduct
  menuProductOrderNote = "menuProduct.orderNote",
  menuProductAddToBasket = "menuProduct.addToBasket",
  menuProductWaiter = "menuProduct.waiter",
  menuProductCallTheWaiter = "menuProduct.callTheWaiter",
  //#endregion
  //#region  template
  templateWaiterFloat = "template.waiterFloat",
  templateTableFloat = "template.tableFloat",
  templateBasketFloat = "template.basketFloat",

  //#endregion
}
